import { useContext } from 'react'
import { WorkoutOverrideModalContext } from 'components/Modals/Popups/WorkoutOverrideModal'

import NumberInput from 'components/Input/NumberInput'

export default function SetUnitsOverrideInput({ 
    phaseIndex, 
    slotIndex, 
    exercise,
    setUnitsDisplayData
 }) {

    const { allowEditing, HandleOverrideChange } = useContext(WorkoutOverrideModalContext)

    const OnSetUnitsChange = (phaseIndex, slotIndex, value) => {
        HandleOverrideChange(
            'one-off-reps-override',
            phaseIndex, 
            slotIndex,
            value
        )
    }

    return (
        <>
            {allowEditing &&
                <>
                    {exercise.setUnit === 'reps' && 
                        <div className='col-span-1 p-2 flex items-center justify-center'>
                            {exercise.lateral === 'unilateral' &&
                                <NumberInput
                                    value={setUnitsDisplayData.value}
                                    onChange={(value) => OnSetUnitsChange(phaseIndex, slotIndex, value) }
                                    className={setUnitsDisplayData.overrideApplied ? 'bg-orange-100' : ''}
                                    subText='reps per side'
                                />
                            }

                            {exercise.lateral === 'bilateral' &&
                                <NumberInput
                                    value={setUnitsDisplayData.value}
                                    onChange={(value) => OnSetUnitsChange(phaseIndex, slotIndex, value) }
                                    className={setUnitsDisplayData.overrideApplied ? 'bg-orange-100' : ''}
                                    subText='reps'
                                />
                            }
                        </div>
                    }
                </>
            }

            {!allowEditing &&
                <>
                    {exercise.setUnit === 'reps' && 
                        <div className='col-span-1 p-2 flex items-center justify-center'>
                            {exercise.lateral === 'unilateral' &&
                                <div>
                                    <p>{setUnitsDisplayData.value}</p>
                                    <div className='pt-1 -mb-1 text-xs'>reps / side</div>
                                </div>
                            }

                            {exercise.lateral === 'bilateral' &&
                                <div>
                                    <p>{setUnitsDisplayData.value}</p>
                                    <div className='pt-1 -mb-1 text-xs'>reps</div>
                                </div>
                            }
                        </div>
                    }
                </>
            }

            {/* Set Units (seconds). TODO: Add support for overriding */}

            {exercise.setUnit === 'seconds' && 
                <div className='col-span-1 p-2 flex items-center justify-center'>
                    {exercise.lateral === 'unilateral' &&
                        <div>
                            <p>{setUnitsDisplayData.value || 10}</p>
                            <div className='pt-1 -mb-1 text-xs'>seconds / side</div>
                        </div>
                    }

                    {exercise.lateral === 'bilateral' &&
                        <div>
                            <p>{setUnitsDisplayData.value || 10}</p>
                            <div className='pt-1 -mb-1 text-xs'>seconds</div>
                        </div>
                    }
                </div>
            }
        </>
    )
}